import { LionInputAmount } from "@lion/input-amount";
import { loadDefaultFeedbackMessages } from "@lion/validate-messages";
import { css } from "lit";
import { LdsBaseInputMixin } from "../../../legl-ui/lds-input";

export class LdsInputAmount extends LdsBaseInputMixin(LionInputAmount) {
  static get styles() {
    return [
      super.styles,
      css`
                :host
                    .input-group__container
                    > .input-group__input
                    ::slotted(.form-control) {
                    text-align: left;
                    padding-left: var(--currency-symbol-padding, 32px);
                }

                :host ::slotted([slot="after"]) {
                    display: none;
                }

                :host ::slotted([slot="prefix"]) {
                    font-style: normal;
                }
            `,
    ];
  }

  static get properties() {
    return {
      currencyCode: { type: String, attribute: "currency-code" },
      locale: { type: String },
    };
  }

  getCurrencySymbol(currencyCode) {
    try {
      const locale = window.navigator.language;
      return (
        new Intl.NumberFormat(locale, {
          style: "currency",
          currency: currencyCode,
        })
          .formatToParts(1)
          .find((part) => part.type === "currency")?.value || currencyCode
      );
    } catch {
      return currencyCode;
    }
  }

  get slots() {
    return {
      ...super.slots,
      prefix: () => {
        if (!this.currencyCode) {
          return null;
        }
        const icon = document.createElement("i");
        icon.classList.add("currency-symbol");
        const currencySymbol = this.getCurrencySymbol(this.currencyCode);
        icon.innerHTML = currencySymbol;
        const currencySymbolPadding = `${24 + currencySymbol.length * 8}`;
        this.style.setProperty(
          "--currency-symbol-padding",
          `${currencySymbolPadding}px`,
        );
        return icon;
      },
    };
  }

  render() {
    loadDefaultFeedbackMessages();
    return super.render();
  }

  get sanitizedValue() {
    // Strip out comma from the amount
    return this.value.replaceAll(",", "");
  }
}

customElements.define("lds-input-amount", LdsInputAmount);
